<div class="contest-ranking__wrapper">
  @if (canCompete) {
    <app-contest-header
      [contest]="contest">
    </app-contest-header>
  }
  <div class="contest-ranking__content"
    [ngClass]="{'contest-ranking__content--border-radius': !canCompete}">
    <table mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      class="contest-ranking__table">
      <ng-container matColumnDef="rank">
        <th mat-header-cell
          *matHeaderCellDef
        class="contest-ranking__header-cell contest-ranking__rank-header">{{ "contest.position" | translate }}</th>
        <td mat-cell
          *matCellDef="let element"
        class="contest-ranking__table-cell contest-ranking__rank-cell">{{ element.rank }}</td>
      </ng-container>
      <ng-container matColumnDef="label">
        <th mat-header-cell
          *matHeaderCellDef
        class="contest-ranking__header-cell contest-ranking__label-header">{{ "contest.class" | translate }}</th>
        <td mat-cell
          *matCellDef="let element"
          class="contest-ranking__table-cell contest-ranking__label-cell">
          <div class="contest-ranking__label-content-wrapper">
            <mat-icon svgIcon="polygon-3"></mat-icon>
            <span>{{ element.label }}</span>
            <mat-icon svgIcon="polygon-3"></mat-icon>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="progress">
        <th mat-header-cell
          *matHeaderCellDef
        class="contest-ranking__header-cell contest-ranking__progress-header">{{ "contest.class_progress" | translate }}</th>
        <td mat-cell
          *matCellDef="let element"
          class="contest-ranking__table-cell contest-ranking__progress-cell">
          <div class="contest-ranking__progress-content-wrapper">
            <span>{{ element.progress }}%</span>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row
        *matHeaderRowDef="columnsToDisplay"
      class="contest-ranking__table-header"></tr>
      <tr mat-row
        *matRowDef="let element; columns: columnsToDisplay;"
        class="contest-ranking__table-row"
        [ngClass]="{'contest-ranking__table-row--selected': element.currentUserRank}">
      </tr>
    </table>
    @if (!canCompete) {
      <div class="contest-ranking__select-wrapper"
        >
        <mat-select class="contest-ranking__select"
                    data-e2e="contest-ranking-group"
          [(value)]="selectedGroup"
          (selectionChange)="changeGroup($event)"
          [aria-label]="'contest.select_group' | translate">
          @for (group of groups; track group) {
            <mat-option
              [value]="group.id">{{ group.get('label') }}
            </mat-option>
          }
        </mat-select>
      </div>
    }
  </div>
</div>